import { Card, CardContent } from "@/components/ui/card";
import { ReactNode } from "react";

interface ReportMetricCardProps {
  value: string | number;
  label: string;
  sublabel?: string | ReactNode;
}

export const ReportMetricCard: React.FC<ReportMetricCardProps> = ({ value, label, sublabel }) => {
  return (
    <Card>
      <CardContent className="flex flex-col justify-between p-0 h-full min-h-[200px]">
        <div className="flex items-center justify-center flex-1">
          <div className="text-8xl font-bold tracking-tight">{value}</div>
        </div>
        <div className="text-center p-4 bg-muted/30">
          <div className="text-sm text-muted-foreground font-medium">
            {label}
          </div>
          {sublabel && (
            <div className="text-xs text-muted-foreground mt-1">{sublabel}</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
};
